export default {
	chooseEffectiveTime: "Choose Effective Time",
	tips: {
		release: "Are you sure to publish the notification?",
		cancelRelease: "Are you sure to cancel publishing the message notification?"
	}
};
